import { useQuery, useQueries } from '@tanstack/react-query';
import useAPI from 'services/useAPI';
import _ from 'lodash';

export const permissionsKeys = {
  all: ['permissions'],
  permissions: () => [...permissionsKeys.all],
  permissionsWithKeys: (keys) => [...permissionsKeys.permissions(), keys]
};

export const useUserPermissionQuery = (userId, resourceType, resourceId, permission) => {
  const api = useAPI();
  const query = useQuery({
    queryKey: permissionsKeys.permissionsWithKeys([resourceId, userId]),
    queryFn: ({ signal }) => {
      if (userId && resourceId) {
        try {
          return api.core.checkPermission(signal, [{
            subjectType: 'user',
            subjectId: userId,
            resourceType: resourceType,
            resourceId: resourceId,
            permission: permission
          }]);
        } catch (err) {
          return null;
        }
      } else {
        return null;
      }
    }
  });
  return query;
};

export const useUserPermissionsQueries = (userId, resourceType, resourceIds, permission) => {
  const api = useAPI();
  const queries = useQueries({
    queries: _.map(resourceIds, resourceId => {
      const query = {
        queryKey: permissionsKeys.permissionsWithKeys([resourceId, userId]),
        queryFn: ({ signal }) => {
          if (userId && resourceId) {
            try {
              return api.core.checkPermission(signal, [{
                subjectType: 'user',
                subjectId: userId,
                resourceType: resourceType,
                resourceId: resourceId,
                permission: permission
              }]);
            } catch (err) {
              return null;
            }
          } else {
            return null;
          }
        }
      };
      return query;
    })
  });
  return queries;
};

